import tippy from 'tippy.js';

class CornerAdoptes {
  constructor() {
    this._init();
  }

  _init() {
    tippy('[data-tippy-content]');
  }
}

export const cornerAdoptes = new CornerAdoptes();
